import { formatDateTime } from '@formosa/shared/utils/formatDateTime';
import {
  MEMBER_ROLE_LABELS,
  PERPETUAL_ORDER_STATUS_LABELS,
  PERPETUAL_ORDER_TREND_LABELS,
  formatAmount,
  formatCloseTime,
  formatLeverage,
  formatOptionalPrice,
  formatPhoneEmail,
  formatStakingDays,
} from './perpetualOrderConstants';
import {
  formatSignedProfitLoss,
  orderTrendClassName,
} from '../../utils/orderDisplayFormat';

function displayValue(value) {
  if (value == null || value === '') {
    return '—';
  }
  return value;
}

function DetailRow({ label, value }) {
  return (
    <div className="product-detail-row">
      <span className="product-detail-row__label">{label}</span>
      <span className="product-detail-row__value">{value}</span>
    </div>
  );
}

export default function PerpetualOrderDetailModal({ open, row, onClose, title = '合約委託單詳情' }) {
  if (!open || !row) {
    return null;
  }

  const trendLabel =
    PERPETUAL_ORDER_TREND_LABELS[row.orderTrend] ||
    row.orderTrendLabel ||
    row.orderTrend ||
    '—';
  const statusLabel =
    PERPETUAL_ORDER_STATUS_LABELS[row.status] || row.statusLabel || row.status || '—';
  const profitLoss = formatSignedProfitLoss(row.profitLoss);

  return (
    <div className="admin-modal-overlay" role="presentation" onClick={onClose}>
      <div
        className="admin-modal admin-modal--wide"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="admin-modal__header">
          <h3>{title}</h3>
          <button type="button" className="admin-modal__close" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="admin-modal__body">
          <div className="product-detail-grid">
            <DetailRow label="用戶ID" value={displayValue(row.memberId)} />
            <DetailRow label="郵箱/手機" value={formatPhoneEmail(row)} />
            <DetailRow label="產品名稱" value={row.tradingPair || row.marketSymbolCode || '—'} />
            <DetailRow label="訂單號" value={displayValue(row.orderSerialId || row.id)} />
            <DetailRow
              label="交易方向"
              value={
                <span className={orderTrendClassName(row.orderTrend)}>{trendLabel}</span>
              }
            />
            <DetailRow label="槓桿倍數" value={formatLeverage(row.contractMultiple)} />
            <DetailRow label="下單金額" value={formatAmount(row.betAmount)} />
            <DetailRow label="下單時間" value={formatDateTime(row.createTime)} />
            <DetailRow label="開倉價" value={formatOptionalPrice(row.orderPrice)} />
            <DetailRow label="平倉價" value={formatOptionalPrice(row.settlementPrice)} />
            <DetailRow
              label="平倉時間"
              value={
                row.closeTime
                  ? formatDateTime(row.closeTime)
                  : row.status === 'OPEN' || row.status === 'PENDING'
                    ? '—'
                    : formatCloseTime(row)
              }
            />
            <DetailRow label="強平價" value={formatOptionalPrice(row.liquidationPrice)} />
            <DetailRow label="起始保證金" value={formatAmount(row.margin)} />
            <DetailRow label="手續費" value={formatAmount(row.fee)} />
            <DetailRow
              label="盈虧金額"
              value={<span className={profitLoss.className}>{profitLoss.text}</span>}
            />
            <DetailRow label="狀態" value={statusLabel} />
            <DetailRow label="帳號類型" value={MEMBER_ROLE_LABELS[row.roleId] || row.roleId || '—'} />
            <DetailRow label="直屬上級用戶ID" value={displayValue(row.inviterId)} />
            <DetailRow label="鎖倉週期(天)" value={formatStakingDays(row.stakingTime)} />
            <DetailRow label="止盈價" value={formatOptionalPrice(row.takeProfitPrice)} />
            <DetailRow label="止損價" value={formatOptionalPrice(row.stopLossPrice)} />
            <DetailRow label="交易前帳戶餘額" value={formatAmount(row.beforeBalance)} />
            <DetailRow label="交易後帳戶餘額" value={formatAmount(row.balance)} />
          </div>
        </div>
        <div className="admin-modal__footer admin-modal__footer--center">
          <button type="button" className="btn btn-danger" onClick={onClose}>
            關閉
          </button>
        </div>
      </div>
    </div>
  );
}
